import { Box, Flex,  Icon, Text, VStack, useBreakpointValue as breakptValue } from '@chakra-ui/react';
import { useContext, useMemo } from 'react'
import { BsPencilSquare, BsFileEarmarkPlus, BsCheckBox, BsCheckCircle } from "react-icons/bs";
import FormStepContext from '../../context/formStepContext';

const StepItem = ({ icon, step, children }) => {
    const currentStep = useContext(FormStepContext)
    // console.log(currentStep)
    // step = current
    // step < current
    // step > current
    const color = useMemo(() => {
        if (step === currentStep) {
            return "blue.600"
        } else if (step < currentStep) {
            return "green.400"
        } else {
            // step > currentStep
            return "gray.300"
        }
    },[step,currentStep])

    const TextIcon = ({ c }) => {
        if (step < currentStep) {
            return (<Icon as={BsCheckCircle} color={c} />)
        } else {
            // step > currentStep
            return (null)
        }
    }

    return (
        <Flex direction="column" align="center">
            <Icon as={icon} w="60px" h="60px" color="white" bgColor={color} borderRadius={10} p={2} />
            <VStack position="absolute" top="260px" align="center">
                <TextIcon color={color} />
                <Text color={color} mt={{base:4,md:0}}>{children}</Text>
            </VStack>
        </Flex>
    )
}

const StepLine = ({ step }) => {
    const currentStep = useContext(FormStepContext)
    const c = () => {
        if (step <= currentStep) {
            return "green.400"
        } else {
            // step > currentStep
            return "gray.300"
        }
    }
    return (<Box w={250} h={2} bgColor={c} />)
}

const FormStepPanel = ({ step }) => {
    
    return (
        <FormStepContext.Provider value={step}>
            <Flex w="full" justify="center" align="center" pb={16}>
                <StepItem icon={BsPencilSquare} step={1}>{breakptValue({base:"กรอก",md:"กรอกแบบฟอร์ม"})}</StepItem>
                <StepLine step={2} />
                <StepItem icon={BsFileEarmarkPlus} step={2}>{breakptValue({base:"แนบ",md:"แนบเอกสาร"})}</StepItem>
                <StepLine step={3} />
                <StepItem icon={BsCheckBox} step={3}>{breakptValue({base:"ยืนยัน",md:"ยืนยันการยื่นแบบฟอร์ม"})}</StepItem>
            </Flex>
        </FormStepContext.Provider>
    )
}

export default FormStepPanel
